import React, { Component } from "react";
import "./LoadingSpinner.css";

class LoadingSpinner extends Component {
  render() {
    if (!this.props.loading) {
      return this.props.children;
    }
    return (
      <div className="row">
        <div className="offset5 span2">
          <div className="loader">Loading...</div>
        </div>
      </div>
    );
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/utils/LoadingSpinner.js